import { Observable } from 'rxjs';

export interface HealthIssueDetails {
  readonly cta?: string;
  readonly description: string;
  readonly details?: string;
  readonly title: string;
}

export abstract class HealthChecker {
  abstract getIssueDetails(): HealthIssueDetails;
  abstract getReport(): { [key: string]: unknown; };
  abstract hasIssue(): Observable<boolean>;
}
